<template>
  <header class="header" :class="headType == 2 ? 'header_bg2' : ''">
    <div
      id="nav-header "
      class="nav-header container"
      v-if="headerData && perhome == 1"
    >
      <a :href="refresh" class="logo">
        <img :src="headerData.website.logo" alt />
      </a>
      <div class="head-l df ai-c">
        <ul class="head-nav clearfix">
          <template v-for="(item, index) of navData">
            <li
              :key="index"
              class="head-nav-item fl pr"
              :style="item.nav_type == 2 ? 'cursor:default' : ''"
              v-if="index < navNum - 1"
              @mouseover="
                item.href == '/course/' ? showClassifyMenu(true) : noHandle
              "
              @mouseout="
                item.href == '/course/' ? showClassifyMenu(false) : noHandle
              "
            >
              <router-link
                v-if="item.href == '/course/'"
                class="head-nav-link"
                to="/course/"
              >
                <span>{{ item.title }}</span>
                <div class="course-menu pr" v-show="classifyVisible">
                  <ul
                    class="menu-first"
                    v-for="(firstItem, index) of headerData.category"
                    :key="index"
                  >
                    <li
                      class="menu-first-li"
                      @mouseover="showChildClassifyMenu(index)"
                      @mouseout="showChildClassifyMenu(-1)"
                    >
                      <router-link
                        :to="'/course/' + firstItem.id + '-0-0-1'"
                        class="menu-first-a tc pr bxbb"
                        :title="firstItem.name"
                        >{{ firstItem.name }}</router-link
                      >
                      <div class="menu-r bxbb" v-show="curMenuIndex == index">
                        <router-link
                          :to="'/course/' + firstItem.id + '-0-0-1'"
                          :title="firstItem.name"
                          class="first-title dib fix sl-t ta3"
                          >{{ firstItem.name }}</router-link
                        >
                        <ul
                          class="menu-second"
                          v-for="(secondItem, index) of firstItem.children"
                          :key="index"
                        >
                          <li class="menu-second-li dif">
                            <router-link
                              :to="
                                '/course/' +
                                firstItem.id +
                                '-' +
                                secondItem.id +
                                '-0-1'
                              "
                              class="menu-second-a sl-t"
                              :title="secondItem.name"
                              >{{ secondItem.name }}</router-link
                            >
                            <ul
                              class="menu-third dib clearfix"
                              v-if="secondItem.children"
                            >
                              <li
                                class="menu-third-li fl"
                                v-for="(
                                  thirdItem, index
                                ) of secondItem.children"
                                :key="index"
                              >
                                <router-link
                                  :to="
                                    '/course/' +
                                    firstItem.id +
                                    '-' +
                                    secondItem.id +
                                    '-' +
                                    thirdItem.id +
                                    '-1'
                                  "
                                  class="menu-third-a"
                                  :title="thirdItem.name"
                                  >{{ thirdItem.name }}</router-link
                                >
                              </li>
                            </ul>
                          </li>
                        </ul>
                      </div>
                    </li>
                  </ul>
                </div>
              </router-link>
              <div
                v-else
                class="head-nav-link"
                :class="
                  item.href == $route.path ||
                  (item.href == '/home' && $route.path == '/')
                    ? 'link_active'
                    : ''
                "
                @click="gotoPath(item, true)"
              >
                <span>{{ item.title }}</span>
              </div>

              <img
                v-if="item.isHot"
                src="@/assets/image/newImg/hot-icon.png"
                class="hotIcon"
              />
              <img
                v-else-if="item.isNew"
                src="@/assets/image/newImg/new-icon.svg"
                class="newIcon"
              />

              <div class="nav-sub-box-li" v-if="item.children">
                <div class="nav-sub-inner-li">
                  <div
                    class="nav-sub-item-li"
                    v-for="(item2, index2) of item.children"
                    :key="index2"
                  >
                    <div class="nav-sub-li" @click="gotoPath(item2)">
                      {{ item2.title }}
                    </div>
                    <div class="nav-third-box-li">
                      <div
                        class="nav-third-li"
                        @click="gotoPath(item3)"
                        v-for="(item3, index3) of item2.children"
                        :key="index3"
                      >
                        {{ item3.title }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </li>
          </template>
          <li
            class="head-nav-item fl pr ico"
            v-if="navData.length >= navNum"
            @mouseover="handleLiOver(true)"
            @mouseout="handleLiOut(false)"
          >
            <i class="el-icon-more" style="font-size: 26px"></i>
            <div class="extra-nav" v-show="liData">
              <div class="nav-box">
                <div class="nav-box-inner">
                  <div v-for="(item, index) of navData" :key="index">
                    <div v-if="item.nav_type == 2">
                      <div
                        class="nav-item"
                        style="cursor: default"
                        v-if="index >= navNum - 1"
                        @mouseover="handleOver(item.id)"
                      >
                        {{ item.title }}
                      </div>
                    </div>
                    <div v-else>
                      <div
                        class="nav-item"
                        v-if="index >= navNum - 1"
                        @mouseover="handleOver(item.id, true)"
                        @click="gotoPath(item)"
                      >
                        {{ item.title }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="nav-sub-box" v-show="subNavData.length">
                <div class="nav-sub-inner">
                  <div
                    class="nav-sub-item"
                    v-for="(item, index) of subNavData"
                    :key="index"
                  >
                    <div class="nav-sub" @click="gotoPath(item)">
                      {{ item.title }}
                    </div>
                    <div class="nav-third-box">
                      <div
                        class="nav-third"
                        @click="gotoPath(item2)"
                        v-for="(item2, index2) of item.children"
                        :key="index2"
                      >
                        {{ item2.title }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <div class="head-r df ai-c">
        <!-- <div class="theme">
          <i class="el-icon-sunny" v-if="colorScheme == 'light'" @click="changScheme('dark')"></i>
          <i class="el-icon-moon" v-else @click="changScheme('light')"></i>
        </div> -->
        <!-- <div class="search-box pr">
          <el-input
            v-model.trim="search_keyword"
            placeholder="搜索感兴趣的课程"
            class="bxbb"
            @keyup.enter.native="searchFn"
          ></el-input>
          <i class="el-icon-search search-icon cp" @click="searchFn"></i>
        </div> -->
        <div class="infoTinps" @click="toMyInfo" v-if="isLogin">
          <el-badge
            :value="infoNum"
            :max="9"
            class="item"
            :hidden="infoNum == 0 ? true : false"
          >
            <span class="el-icon-message-solid"></span>
          </el-badge>
        </div>
        <!-- 未登录 -->
        <a
          href="javascript:void(0);"
          class="noLogin-btn"
          @click="signIn"
          v-if="!isLogin"
          ref="login"
          >{{ website.is_open_register ? "登录/注册" : "登录" }}</a
        >
        <!-- 已登录 -->
        <div
          class="login-out pr"
          @mouseenter="showSubMenu(true)"
          @mouseleave="showSubMenu(false)"
          v-else
        >
          <div class="hd">
            <span class="uesrName">{{ name }}</span>
            <router-link to class="avatar">
              <img :src="avatar" alt />
            </router-link>
          </div>
          <transition name="el-zoom-in-top">
            <ul class="bd sub-menu tc fix" v-show="menuSeen">
              <li v-if="systemVisible">
                <a href="http://admin.yiihuu.com/1" class="pr">管理后台</a>
              </li>
              <li>
                <router-link to="/u/profile/" class="pr">个人中心</router-link>
              </li>
              <li>
                <router-link to="/s/mycourse/" class="pr">学习中心</router-link>
              </li>
              <li>
                <router-link to="/myWorks/" class="pr">作品管理</router-link>
              </li>
              <li>
                <router-link to="/u/pay/" class="pr">充值中心</router-link>
              </li>
              <li>
                <router-link to class="pr" @click.native="handleLogout"
                  >退出登录</router-link
                >
              </li>
            </ul>
          </transition>
        </div>
      </div>
    </div>
    <div id="nav-header" class="nav-header container" v-if="perhome == 2">
      <div
        class="head-l df ai-c"
        v-if="headerData.website && headerData.website.logo"
      >
        <a :href="refresh" class="logo">
          <img :src="headerData.website.logo" alt />
        </a>
        <div class="headPerson">
          <div>
            <router-link to="/s/mycourse/" class="pr">
              <i class="el-icon-s-custom"></i>学习中心
            </router-link>
          </div>
          <div>
            <router-link to="/u/" class="pr">
              <i class="el-icon-video-camera-solid"></i>个人中心
            </router-link>
          </div>
        </div>
      </div>
      <div class="head-r df ai-c">
        <!-- <div class="theme">
          <i class="el-icon-sunny" v-if="colorScheme == 'light'"></i>
          <i class="el-icon-moon" v-else></i>
        </div> -->
        <div class="manageBtnWrap" v-if="identity_type == 1 && isWF == 1">
          <el-button
            class="mangeBtn"
            type="primary"
            size="mini"
            @click="toManageAdmin"
            >管理后台</el-button
          >
        </div>
        <div class="infoTinps" @click="toMyInfo" v-if="isLogin">
          <el-badge
            :value="infoNum"
            :max="9"
            class="item"
            :hidden="infoNum == 0 ? true : false"
          >
            <span class="el-icon-message-solid"></span>
          </el-badge>
        </div>
        <!-- 未登录 -->
        <a
          href="javascript:void(0);"
          class="noLogin-btn"
          @click="signIn"
          v-if="!isLogin"
          ref="login"
          >{{ website.is_open_register ? "登录/注册" : "登录" }}</a
        >
        <!-- 已登录 -->
        <div
          class="login-out pr"
          @mouseover="showSubMenu(true)"
          @mouseout="showSubMenu(false)"
          v-else
        >
          <div class="hd">
            <span>{{ name }}</span>
            <router-link to class="avatar">
              <img :src="avatar" alt />
            </router-link>
          </div>
          <ul class="bd sub-menu tc fix" v-show="menuSeen">
            <li>
              <router-link to="/u/" class="pr">个人中心</router-link>
            </li>
            <li>
              <router-link to="/s/mycourse/" class="pr">学习中心</router-link>
            </li>
            <li>
              <router-link to="/myWorks/" class="pr">作品管理</router-link>
            </li>
            <li>
              <router-link to class="pr" @click.native="handleLogout"
                >退出登录</router-link
              >
            </li>
          </ul>
        </div>
      </div>
    </div>
    <!-- 登录弹窗 start -->
    <login ref="loginDialog"></login>
    <!-- 登录弹窗 end -->
    <!-- 登录弹窗 start -->
    <resetPassword ref="resetPasswordDialog"></resetPassword>
    <!-- 登录弹窗 end -->
  </header>
</template>
<script>
import login from "@/components/login";
import resetPassword from "@/components/reset_password";
import { getToken, getOid } from "@/utils/auth";
import store from "@/store";
import { mapGetters } from "vuex";
import { headerInfo, navInfo, getAutodlUrl } from "@/api/header";
import { organization } from "@/utils/common";
export default {
  name: "commonHeader",
  components: {
    login,
    resetPassword,
  },
  props: {
    headType: {
      type: Number,
      default: 1,
    },
  },

  data() {
    return {
      isLogin: false,
      menuSeen: false,
      search_keyword: "",
      classifyVisible: false,
      headerData: "",
      curMenuIndex: null,
      systemVisible: 0,
      isWF: 1,
      navNum: 8,
      navData: [],
      liData: false,
      subNavData: [],
      colorScheme: "dark",
    };
  },
  methods: {
    // 初始化导航信息
    initNavData() {
      let data = {
        type: 1,
        is_tree: 1,
        status: 1,
      };
      navInfo(data).then((res) => {
        this.navData = res.data;
        if (this.website.is_ai) {
          let aiArr = [];
          if (this.website.ai_show_setting.sdyh)
            aiArr.push({ title: "简易模式", href: "", ai_type: 2 });
          if (this.website.ai_show_setting.sd)
            aiArr.push({ title: "专业模式", href: "", ai_type: 0 });
          if (this.website.ai_show_setting.comfyui)
            aiArr.push({ title: "工作流模式", href: "", ai_type: 1 });
          this.navData.splice(2, 0, {
            title: "AI创作",
            nav_type: 2,
            children: aiArr,
          });
          // this.navData.splice(2, 0, {
          //   title: "AI创作",
          //   nav_type: 1,
          //   href: "",
          //   ai_type: 0,
          // });
        }

        this.navData.forEach((e) => {
          if (e.href_type == 3) {
            switch (e.href) {
              case "/studentcms": {
                this.$store.commit("SET_STUDENTCMSNAME", e.title);
                break;
              }
              case "/infocms": {
                this.$store.commit("SET_INFOCMSNAME", e.title);
                break;
              }
            }
          }
        });
      });
    },
    // 传到父
    sendFather(data) {
      this.$emit("navdata", data);
    },

    // 前往我的消息
    toMyInfo() {
      this.$store.commit("user/SET_STUTAB", "myinfo");
      this.$router.push("/s/myinfo");
    },
    // 前往前台前端页面首页
    toManageAdmin() {
      let href = location.href;
      let hrefHost = href.split("/")[0];
      window.open(hrefHost + "/admin/");
      // window.open(process.env.BASE_ADMIN_API)
    },
    // 初始化搜索框关键字
    initKeyword() {
      var routeQuery = this.$route.query,
        keyword = routeQuery.q;
      if (keyword) {
        this.search_keyword = keyword;
      }
    },
    // 搜索
    searchFn() {
      if (this.search_keyword.trim() == "") return;
      const query = this.$route.query;

      if (query.q && this.search_keyword == query.q) {
        //二次搜索同一关键字时
        this.$router.go(0);
      } else {
        //搜索不同关键字
        this.$router.push("/course/?q=" + this.search_keyword);
      }
    },
    // 打开登录弹窗
    signIn() {
      this.$refs.loginDialog.showLoginDialog();
      if (this.$route.path === "/") {
        document.getElementsByClassName("header")[0].style.paddingRight =
          "17px";
      }
    },
    // 获取用户信息
    async getUserInfoToken() {
      if (getToken() !== undefined) {
        try {
          let response = await this.$store.dispatch("user/getInfo");
          this.systemVisible = response.is_admin;
          localStorage.setItem("oid", response.oid);
          this.isLogin = true;
        } catch (err) {}
      }
    },
    // 退出登录
    handleLogout() {
      this.$store
        .dispatch("user/logout")
        .then((response) => {
          if (typeof wf != "undefined") {
            wf.winReload();
          } else {
            if (this.$route.name == "personal" || this.$route.name == "study") {
              location.href = location.origin;
            } else {
              location.reload();
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    // 初始化公共头部信息
    initHeaderInfo() {
      headerInfo()
        .then((response) => {
          this.sendFather(response.data.nav);
          const resData = response.data;
          this.headerData = resData;
          this.$store.commit("user/SET_CARDINFO", resData.org);
          // this.$store.commit('SET_HOME',resData.website.is_home);
          // this.$store.commit('SET_INTEREST',resData.website.is_lear_interest);
          // 设置浏览器标签页小图标(<link rel="icon">)
          document.querySelector('link[rel="icon"]').href =
            this.headerData.website.icon;
          // 设置浏览器标签页标题(<title></title>)
          if (this.headerData.website.subtitle) {
            document.querySelector("title").innerText =
              this.headerData.website.title +
              " - " +
              this.headerData.website.subtitle;
          } else {
            document.querySelector("title").innerText =
              this.headerData.website.title;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    // 打开课程中心导航栏菜单
    showSubMenu(boolean_) {
      this.menuSeen = boolean_;
    },
    showClassifyMenu(boolean_) {
      this.classifyVisible = boolean_;
    },
    showChildClassifyMenu(index_) {
      this.curMenuIndex = index_;
    },

    // 没有操作（不能删）
    noHandle() {},

    // 头部导航栏跳转链接
    handlePath(item) {
      let _title = item.title;
      let _url = item.href;
      let _isblank = item.is_blank;
      let _hrefType = item.href_type; // 类型2 自定义页面, 其它是自定义链接
      let _target = _isblank == 0 ? "_self" : "_blank";
      let _env = process.env.NODE_ENV;
      let _preto = _env == "production" ? "https://" : "http://";
      if (_hrefType != 2) {
        if (_url.indexOf("/") == 0) {
          this.$router.push(_url);
        } else {
          if (_url.indexOf("http") != -1) {
            window.open(_url, _target);
          } else {
            let allUrl = `${_preto}${_url}`;
            window.open(allUrl, _target);
          }
        }
      } else {
        let host = location.host;
        let cusUrl = `${_preto}${host}/diypage/${_url}`;
        if (_env == "development") {
          cusUrl = `${_preto}${host}/yh/diypage/${_url}`;
        }
        localStorage.setItem("course_frot_nav_title", _title);
        window.open(cusUrl, _target);
      }
    },
    setPaddingRight() {
      this.$nextTick(() => {
        document.getElementsByClassName("header")[0].style.paddingRight =
          "17px";
      });
    },
    windowResize() {
      let resizeId = null;
      if (window.innerWidth <= 1500) {
        this.navNum = 5;
      } else {
        this.navNum = 8;
      }
      window.addEventListener("resize", () => {
        if (resizeId) clearTimeout(resizeId);
        resizeId = setTimeout(() => {
          if (window.innerWidth <= 1500) {
            this.navNum = 5;
          } else {
            this.navNum = 8;
          }
        }, 100);
      });
    },
    gotoPath(val_, isFirst) {
      if (isFirst && val_.nav_type == 2) return;

      let isSdAi = val_.href.indexOf("sd-aigc.yiihuu.com");
      if (isSdAi != -1 && !this.isLogin) {
        this.signIn();
        return;
      }

      switch (val_.ai_type) {
        case 2:
          let lartaiUrl = `${process.env.BASE_LARTAI_URL}?oid=${getOid()}`;
          //if (getToken()) lartaiUrl += `&aigc_ck=${getToken()}`;
          if (getToken()) lartaiUrl += `&usertoken=${getToken()}&userKey=aigc@aigc`;
          window.open(lartaiUrl, "_blank");
          return;

        // case 0:
        //   if (getToken()) {
        //     this.$router.push("/ai-tool");
        //   } else {
        //     this.signIn();
        //   }

        //   return;
        case 0:
        case 1:
          if (getToken()) {
            getAutodlUrl({ ai_type: val_.ai_type }).then((resp) => {
              if (resp.status) {
                window.open(
                  `${
                    resp.data.service_url
                  }?__theme=dark&token=${getToken()}&oid=${getOid()}`,
                  "_blank"
                );
              }
            });
          } else {
            this.signIn();
          }
          return;
      }

      if (val_.nav_type == 1) {
        if (val_.href_type == 3) {
          this.gotoNow(val_.href, val_.is_blank);
        } else if (val_.href_type == 1) {
          if (val_.is_blank == 1) {
            window.open(val_.href, "_blank");
          } else {
            window.location.href = val_.href;
          }
        } else if (val_.href_type == 2) {
          this.gotoNow(`/diypages/${val_.href}/` + val_.id, val_.is_blank);
        } else {
          this.$router.push("/");
        }
      } else {
        if (val_.children) {
          let eArr = [];
          var bool = val_.children.findIndex((e, i) => {
            if (e.children) {
              eArr.push(e.children);
            }
            return e.nav_type == 1;
          });
          if (bool != -1) {
            this.gotoNow(
              `/diypages/${val_.children[bool].href}/` + val_.children[bool].id,
              val_.children[bool].is_blank
            );
          } else {
            if (eArr.length) {
              eArr.some((item, j) => {
                var eBool = eArr[j].findIndex((e, i) => {
                  return e.nav_type == 1;
                });
                if (eBool != -1) {
                  this.gotoNow(
                    `/diypages/${eArr[j][eBool].href}/` + eArr[j][eBool].id,
                    eArr[j][eBool].is_blank
                  );
                  return true;
                } else if (eBool == -1 && j == eArr.length - 1) {
                  this.$message({
                    type: "warning",
                    message: "页面暂无内容",
                    customClass: "zIndex4000",
                  });
                }
              });
            } else {
              this.$message({
                type: "warning",
                message: "页面暂无内容",
                customClass: "zIndex4000",
              });
            }
          }
        } else {
          this.$message({
            type: "warning",
            message: "页面暂无内容",
            customClass: "zIndex4000",
          });
        }
      }
    },
    gotoNow(href_, blank_) {
      if (blank_ == 1) {
        window.open(href_, "_blank");
      } else {
        if (
          this.$route.name != "Diypages" ||
          href_ == "/tearchcms" ||
          href_ == "/studentcms" ||
          href_ == "/teamcms" ||
          href_ == "/infocms" ||
          href_ == "/"
        ) {
          this.$router.push(href_);
        } else {
          this.$router.push(href_);
          location.reload();
        }
      }
    },
    handleOver(val_, isNull) {
      if (isNull) {
        this.subNavData = [];
        return;
      }
      for (let i = 0; i < this.navData.length; i++) {
        if (val_ == this.navData[i].id) {
          this.navThisNum = this.navData[i].id;
          if (this.navData[i].children) {
            this.subNavData = this.navData[i].children;
          } else {
            this.subNavData = [];
          }
        }
      }
    },
    handleLiOver(val_) {
      this.liData = val_;
    },
    handleLiOut(val_) {
      this.liData = val_;
      // this.subNavData = []
    },
    changScheme(val) {
      let html = document.getElementsByTagName("html")[0];
      html.className = val;
      localStorage.setItem("colorScheme", val);
      this.colorScheme = val;
    },
  },
  created: function () {
    if (typeof wf != "undefined") {
      wf.ready(function () {});
      this.isWF = 0;
    }
    this.initKeyword();
    this.getUserInfoToken();
    this.initHeaderInfo();
    this.windowResize();
    this.initNavData();
    // this.colorScheme = localStorage.getItem("colorScheme");
  },
  mounted: function () {
    // if(typeof wf != "undefined"){
    //   wf.ready(function(){});
    //   this.isWF = 0;
    // }
    // this.initKeyword();
    // this.getUserInfoToken();
    // this.initHeaderInfo();
  },
  computed: {
    ...mapGetters([
      "name",
      "avatar",
      "interest",
      "perhome",
      "identity_type",
      "infoNum",
      "website",
    ]),
    // 首页logo刷新
    refresh() {
      return "/";
      // if (organization.id) {
      //   return `/${organization.id}/`;
      // } else {
      // return "/";
      // }
    },
  },
};
</script>
<style lang="scss" scoped>
.header_bg2 {
  background: #222222 !important;
}

.header {
  width: 100%;
  height: 80px;
  min-width: 1170px;
  // line-height: 80px;
  background: rgba(0, 0, 0, 0.39);
  backdrop-filter: blur(12px);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
  box-sizing: border-box;
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.1);
  color: #fff;

  .nav-header {
    display: flex;
    flex-wrap: nowrap;
    height: 100%;
    width: 100%;

    .logo {
      display: flex;
      width: 250px;
      justify-content: flex-start;
      align-items: center;
      flex-shrink: 0;

      img {
        display: block;
        max-height: 100%;
      }
    }

    .head-l {
      height: 100%;
      flex: 1;
      flex-wrap: nowrap;
      // min-width: 600px;
      justify-content: center;

      .head-nav {
        height: 100%;
        display: flex;

        // max-width: 525px;
        .head-nav-item {
          display: flex;
          align-items: center;
          max-width: 160px;
          padding: 0 17px;
          cursor: pointer;
          box-sizing: border-box;

          &:hover {
            .nav-sub-box-li {
              display: block;
            }
          }

          .nav-sub-box-li {
            box-shadow: 0px 6px 6px rgba(0, 0, 0, 0.16);
            display: none;
            position: absolute;
            top: 80px;
            left: 0;
            padding: 2px 0 10px;
            background-color: rgba(0, 0, 0, 0.6);
            border-radius: 0 0 10px 10px;

            .nav-sub-inner-li {
              max-width: 316px;
              min-width: 120px;
              max-height: 403px;
              overflow: auto;

              &::-webkit-scrollbar {
                /*滚动条整体样式*/
                /*高宽分别对应横竖滚动条的尺寸*/
                width: 5px;
                height: 1px;
              }

              &::-webkit-scrollbar-thumb {
                /*滚动条里面小方块*/
                border-radius: 10px;
                -webkit-box-shadow: inset 0 0 5px #dcdcdc;
                background: #dcdcdc;
              }

              &::-webkit-scrollbar-track {
                /*滚动条里面轨道*/
                -webkit-box-shadow: inset 0 0 5px #f0f5ff;
                border-radius: 10px;
                background: transparent;
              }
            }

            .nav-sub-item-li {
              padding-bottom: 8px;
              text-align: center;

              .nav-sub-li {
                cursor: pointer;
                padding: 15px 16px;
                padding-bottom: 7px;
                font-size: 14px;
                color: #ccc;
                white-space: nowrap;
                max-width: 316px;
                overflow: hidden;
                text-overflow: ellipsis;

                &:hover {
                  color: #6257ff;
                  background-color: #070e13;
                }
              }

              &:hover {
                color: #6257ff;
                background-color: #070e13;
              }

              .nav-third-box-li {
                .nav-third-li {
                  cursor: pointer;
                  display: inline-block;
                  margin-top: 7px;
                  box-sizing: border-box;
                  padding-left: 16px;
                  font-size: 12px;
                  color: #676767;

                  &:hover {
                    color: #6257ff;
                  }
                }
              }
            }
          }

          .hotIcon {
            width: 15px;
            height: 18px;
            padding-left: 6px;
          }

          .newIcon {
            width: 29px;
            height: 16px;
            padding-left: 6px;
          }

          .head-nav-link {
            display: block;
            // max-width: 116px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            height: 60px;
            line-height: 60px;
            color: #fff;
            position: relative;
            min-width: 50px;
            text-align: center;
            span {
              position: relative;
              z-index: 2;
            }
            &::after {
              content: "";
              position: absolute;
              top: 50%;
              left: 52%;
              transform: translate(-50%, -50%);
              width: 47px;
              height: 26px;
              background: url(../assets/image/home/active.png) no-repeat;
              background-size: 100% 100%;
              z-index: 1;
              opacity: 0;
              transition: all 0.3s;
            }
          }

          .head-nav-link:hover,
          .link_active {
            .icon {
              font-weight: bold;
            }
            &::after {
              opacity: 1;
            }
          }

          .course-menu {
            box-shadow: 0px 0px 10px 0px rgba(24, 23, 22, 0.1);
            position: absolute;
            top: 80px;
            left: 10px;
            z-index: 1000;
            border-radius: 0px 0px 0px 5px;

            a {
              color: #ccc;
            }

            .menu-first {
              width: 112px;
              background: rgba(0, 0, 0, 0.6);

              .menu-first-li {
                .menu-first-a {
                  width: 100%;
                  display: block;
                  height: 40px;
                  line-height: 40px;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  padding-left: 5px;
                }

                &:hover .menu-first-a {
                  background-color: #070e13;
                  color: #6257ff;
                  font-weight: bold;
                }
              }
            }

            .menu-first:last-child {
              width: 112px;
              background: rgba(0, 0, 0, 0.6);
              border-radius: 0px 0px 0px 5px;

              .menu-first-li {
                .menu-first-a {
                  display: block;
                  height: 40px;
                  line-height: 40px;
                }

                &:hover .menu-first-a {
                  background-color: #070e13;
                  color: #6257ff;
                  font-weight: bold;
                  border-radius: 0px 0px 0px 5px;
                }
              }
            }

            .menu-r {
              position: absolute;
              left: 112px;
              top: 0;
              background-color: #070e13;
              border-radius: 0px 0px 5px 0px;
              max-width: 400px;
              padding-left: 40px;
              padding-top: 14px;
              min-height: 100%;
              max-height: 600px;
              overflow: auto;
              min-width: 149px;

              .first-title {
                height: 32px;
                line-height: 32px;
                background-color: #13242e;
                border-radius: 3px;
                max-width: 180px;
                padding: 0 8px;
                margin: 0 20px 15px 0;
                color: #ccc;
                font-size: 14px;

                &:hover {
                  background-color: #6257ff;
                  color: #fff;
                }
              }

              .menu-second {
                line-height: initial;

                .menu-second-li {
                  margin-bottom: 14px;

                  .menu-second-a {
                    width: 102px;
                    display: inline-block;
                    vertical-align: top;
                    margin-right: 12px;

                    &:hover {
                      color: #6257ff;
                      font-weight: 400;
                    }
                  }
                }
              }

              .menu-third {
                width: 230px;
                display: inline-block;
                vertical-align: top;

                .menu-third-li {
                  margin-bottom: 5px;
                  margin-right: 20px;

                  .menu-third-a {
                    font-size: 12px;

                    &:hover {
                      color: #6257ff;
                    }
                  }
                }
              }
            }

            .menu-r::-webkit-scrollbar {
              /*滚动条整体样式*/
              /*高宽分别对应横竖滚动条的尺寸*/
              width: 8px;
              height: 1px;
            }

            .menu-r::-webkit-scrollbar-thumb {
              /*滚动条里面小方块*/
              border-radius: 10px;
              -webkit-box-shadow: inset 0 0 5px #dcdcdc;
              background: #dcdcdc;
            }

            .menu-r::-webkit-scrollbar-track {
              /*滚动条里面轨道*/
              -webkit-box-shadow: inset 0 0 5px #f0f5ff;
              border-radius: 10px;
              background: transparent;
            }
          }

          .extra-nav {
            box-shadow: 0px 6px 6px rgba(0, 0, 0, 0.3);
            display: none;
            position: absolute;
            top: 80px;
            left: 0;
            display: flex;
            max-height: 415px;
            background-color: rgba(0, 0, 0, 0.6);
            border-radius: 0 0 10px 10px;

            .nav-box {
              padding: 2px 0 10px;
              width: 120px;

              .nav-box-inner {
                max-height: 403px;
                overflow: hidden;

                &:hover {
                  overflow: auto;

                  &::-webkit-scrollbar {
                    /*滚动条整体样式*/
                    /*高宽分别对应横竖滚动条的尺寸*/
                    width: 5px;
                    height: 1px;
                  }

                  &::-webkit-scrollbar-thumb {
                    /*滚动条里面小方块*/
                    border-radius: 10px;
                    -webkit-box-shadow: inset 0 0 5px #dcdcdc;
                    background: #dcdcdc;
                  }

                  &::-webkit-scrollbar-track {
                    /*滚动条里面轨道*/
                    -webkit-box-shadow: inset 0 0 5px #f0f5ff;
                    border-radius: 10px;
                    background: transparent;
                  }
                }
              }

              .nav-item {
                width: 100%;
                text-align: center;
                padding: 16px 10px;
                font-size: 16px;
                box-sizing: border-box;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
                color: #ccc;
                cursor: pointer;

                &:hover {
                  color: #6257ff;
                  background-color: #070e13;
                }
              }
            }

            .nav-sub-box {
              position: relative;
              padding: 2px 0 10px;
              border-left: 1px solid #13242e;

              .nav-sub-inner {
                width: 311px;
                max-height: 403px;
                overflow: hidden;
                margin-right: 5px;

                &:hover {
                  overflow: auto;

                  &::-webkit-scrollbar {
                    /*滚动条整体样式*/
                    /*高宽分别对应横竖滚动条的尺寸*/
                    width: 5px;
                    height: 1px;
                  }

                  &::-webkit-scrollbar-thumb {
                    /*滚动条里面小方块*/
                    border-radius: 10px;
                    -webkit-box-shadow: inset 0 0 5px #dcdcdc;
                    background: #dcdcdc;
                  }

                  &::-webkit-scrollbar-track {
                    /*滚动条里面轨道*/
                    -webkit-box-shadow: inset 0 0 5px #f0f5ff;
                    border-radius: 10px;
                    background: transparent;
                  }
                }
              }

              .nav-sub-item {
                padding-left: 16px;
                margin: 10px 0 30px;

                .nav-sub {
                  cursor: pointer;
                  font-size: 14px;
                  color: #ccc;

                  &:hover {
                    color: #6257ff;
                  }
                }

                .nav-third-box {
                  .nav-third {
                    cursor: pointer;
                    display: inline-block;
                    margin-right: 12px;
                    margin-top: 14px;
                    font-size: 12px;
                    color: #676767;

                    &:hover {
                      color: #6257ff;
                    }
                  }
                }
              }
            }
          }
        }

        .ico {
          &:hover {
            .extra-nav {
              display: flex;
            }

            color: #6257ff;
          }
        }
      }
    }

    .head-r {
      max-width: 495px;
      min-width: 120px;

      .theme {
        margin-right: 15px;

        i {
          font-size: 18px;
          cursor: pointer;
        }
      }

      .search-box {
        background-color: #fff;
        margin-right: 28px;

        /deep/ .el-input__inner {
          height: 30px;
          line-height: 30px;
          width: 180px;
          padding-left: 10px;
          font-size: 12px;
          border-radius: 5px;
          border: solid 1px #ccc;

          &:focus {
            border-color: #6257ff;
          }
        }

        .search-icon {
          position: absolute;
          right: 12px;
          top: 50%;
          transform: translate(0, -50%);
          color: #8c8c8c;
        }
      }

      .noLogin-btn {
        color: #fff;

        &:hover {
          color: #6257ff;
        }
      }

      .login-out {
        height: 100%;
        // line-height: 60px;
        display: flex;
        align-items: center;
        color: #333;
        min-width: 125px;

        .hd {
          .uesrName {
            display: inline-block;
            max-width: 70px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            vertical-align: middle;
            color: #fff;
          }

          .avatar {
            display: inline-block;
            margin-left: 12px;

            img {
              width: 36px;
              height: 36px;
              border-radius: 50%;
              box-shadow: 0px 0px 6px 0px #ddd;
            }
          }
        }

        .sub-menu {
          position: absolute;
          top: 60px;
          right: 0;
          left: 12%;
          z-index: 1000;
          width: 96px;
          background-color: #f5f5f5;
          box-shadow: 0px 0px 10px 0px rgba(24, 23, 22, 0.1);
          border-radius: 0px 0px 5px 5px;

          a {
            display: block;
            height: 40px;
            line-height: 40px;

            &:hover {
              background-color: #fff;

              &::before {
                content: "";
                display: block;
                font-size: 0;
                overflow: hidden;
                width: 4px;
                height: 40px;
                background-color: #6257ff;
                position: absolute;
                left: 0;
                top: 0;
              }
            }
          }
        }
      }
    }
  }

  .head-nav-more {
    padding: 0 17px;
    font-size: 24px;
    height: 60px;
    line-height: 60px;
    color: #333;
    position: relative;

    &:hover {
      .more-nav-wrap {
        display: block;
      }
    }

    .more-nav-wrap {
      display: none;
      position: absolute;
      top: 60px;
      left: 0;
      width: 112px;
      font-size: 14px;
      font-weight: 400;
      color: #333333;
      background: #f5f5f5;
      border-radius: 0px 0px 6px 6px;
      overflow: hidden;
      text-align: center;

      .more-nav-item {
        span {
          display: block;
          cursor: pointer;
          padding: 14px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          line-height: 18px;
        }

        &:hover {
          background: #ffffff;
          font-weight: bold;
          color: #058afd;
        }
      }
    }
  }
}

.router-link-exact-active,
.router-link-active {
  &::after {
    opacity: 1 !important;
  }
}

.infoTinps {
  font-size: 18px;
  padding-right: 20px;
  cursor: pointer;

  &:active {
    opacity: 0.7;
  }
}

/deep/ .mangeBtn {
  width: 75px !important;
  margin-right: 25px;
  font-size: 14px;
  padding: 7px 7px;
}

.headPerson {
  display: flex;

  div {
    padding: 0 10px;

    i {
      font-size: 16px;
    }

    &.active {
      color: #6257ff;
      font-weight: 700;
    }

    &:hover {
      color: #6257ff;
      font-weight: 700;
    }
  }
}

// @media screen and (max-width: 1600px) {
//   .container {
//     max-width: 1100px;
//   }
// }
</style>



// WEBPACK FOOTER //
// src/components/header.vue